/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import WizardModern from "@src/views/referral/WizardModern";

const Referral = () => {
	return <WizardModern/>
};

export default Referral;
